export async function startConversation(supabase, workerId, employerId, jobId, currentUserType = 'worker') {
  // Worker+employer share one ongoing thread regardless of which job it's about —
  // job_id is only used to seed a brand new conversation, never as a lookup key.
  const { data: existingRows } = await supabase
    .from('conversations')
    .select('id, worker_hidden_at, employer_hidden_at')
    .eq('worker_id', workerId)
    .eq('employer_id', employerId)
    .order('created_at', { ascending: false });

  const existing = (existingRows || []).find(row => {
    const hiddenByCurrentUser = currentUserType === 'employer' ? row.employer_hidden_at : row.worker_hidden_at;
    return !hiddenByCurrentUser;
  });

  if (existing) return existing.id;

  const { data: created } = await supabase
    .from('conversations')
    .insert({ worker_id: workerId, employer_id: employerId, job_id: jobId || null })
    .select('id')
    .single();

  return created?.id || null;
}
